import React from 'react';
import SelectBarTriangle from './SelectBarTriangle.jsx';

const OptionCard = ({ img, title, desc, onClick, isSelected = false, disabled }) => {
    let addClass;
    if (isSelected) {
        addClass = ' selected-card';
    } else {
        addClass = disabled ? ' lock-card' : '';
    }

    return (
        <div className={`appraisal-form-options-container--card${addClass}`} onClick={onClick}>
            <div>
                <div className="option-header">
                    <div className="option-header--img-container">
                        <img src={img} alt={title} />
                        <icon className="icon-cbb-icons-checked-option option-header--img-container--overlay" />
                    </div>
                    <p>{title}</p>
                </div>
                <p className="option-desc">{desc}</p>
            </div>
            <SelectBarTriangle />
        </div>
    );
};

export default OptionCard;

OptionCard.displayName = 'OptionCard';
